import * as _ from 'lodash';
import * as firebase from 'firebase';

import * as types from '../actionTypes';

export function updateApplicationNetworkState(isOnline) {
  return (dispatch) => {
    dispatch({
      type: isOnline ? types.APP_NETWORK_ONLINE : types.APP_NETWORK_OFFLINE,
    });
  };
}

const clientRealtimeDataObservers = [];
/* { eventType, ref, observer, onSnapshot, onCancel } */

function startClientRealtimeDataObservers() {
  clientRealtimeDataObservers.forEach((context, index) => {
    context.onSubscribe();
    clientRealtimeDataObservers[index].observer = context.ref.on(
      context.eventType,
      context.onSnapshot,
      context.onCancel,
    );
  });
}
function stopClientRealtimeDataObservers(willCancelCallback = () => {}) {
  if (clientRealtimeDataObservers.length === 0) { return; }

  willCancelCallback();
  clientRealtimeDataObservers.forEach((context, index) => {
    context.onUnsubscribe();
    context.ref.off(context.eventType, context.observer);
    delete clientRealtimeDataObservers[index];
  });
}

function fbGenerateFleetlyRef(clientPath, client, fleet) {
  let ref = firebase.database().ref(`/clients/${client}`).child(clientPath);

  if (!fleet) {
    ref = ref.orderByChild('fleet').equalTo(null);
  } else if (fleet !== '_all') {
    ref = ref.orderByChild('fleet').equalTo(fleet);
  }

  return ref;
}

export function observeClientRealtimeData(client, fleet) {
  return (dispatch) => {
    // stop current observers
    stopClientRealtimeDataObservers(() => dispatch({
      type: types.APP_REALTIME_CLIENT_DATA_UNSUBSCRIBE,
    }));

    if (client) {
      dispatch({
        type: types.APP_REALTIME_CLIENT_DATA_SUBSCRIBE,
        client,
      });

      // observe vehicles
      clientRealtimeDataObservers.push({
        ref: fbGenerateFleetlyRef('/vehicle/vehicles', client, fleet),
        eventType: 'value',
        onSubscribe: () => dispatch({
          type: types.VEHICLES_REALTIME_DATA_SUBSCRIBE,
        }),
        onUnsubscribe: () => dispatch({
          type: types.VEHICLES_REALTIME_DATA_UNSUBSCRIBE,
        }),
        onSnapshot: _.debounce(snap => dispatch({
          type: types.VEHICLES_REALTIME_DATA_PUBLISH,
          data: snap.val(),
        }), 600),
        onCancel: error => dispatch({
          type: types.VEHICLES_REALTIME_DATA_FAILURE,
          error,
        }),
      });

      // observe drivers
      clientRealtimeDataObservers.push({
        ref: fbGenerateFleetlyRef('/driver/drivers', client, fleet),
        eventType: 'value',
        onSubscribe: () => dispatch({
          type: types.DRIVERS_REALTIME_DATA_SUBSCRIBE,
        }),
        onUnsubscribe: () => dispatch({
          type: types.DRIVERS_REALTIME_DATA_UNSUBSCRIBE,
        }),
        onSnapshot: _.debounce(snap => dispatch({
          type: types.DRIVERS_REALTIME_DATA_PUBLISH,
          data: snap.val(),
        }), 600),
        onCancel: error => dispatch({
          type: types.DRIVERS_REALTIME_DATA_FAILURE,
          error,
        }),
      });

      // observe fleets
      clientRealtimeDataObservers.push({
        ref: firebase.database().ref(`/clients/${client}/fleet/fleets`),
        eventType: 'value',
        onSubscribe: () => dispatch({
          type: types.FLEETS_REALTIME_DATA_SUBSCRIBE,
        }),
        onUnsubscribe: () => dispatch({
          type: types.FLEETS_REALTIME_DATA_UNSUBSCRIBE,
        }),
        onSnapshot: _.debounce(snap => dispatch({
          type: types.FLEETS_REALTIME_DATA_PUBLISH,
          data: snap.val(),
        }), 600),
        onCancel: error => dispatch({
          type: types.FLEETS_REALTIME_DATA_FAILURE,
          error,
        }),
      });

      startClientRealtimeDataObservers();
    }
  };
}



// WEBPACK FOOTER //
// ./src/App/app.actions.js